module.exports = __webpack_public_path__ + "static/pic02-94a7f01130eea248cc254c7d66434c1b.jpg";